import 'core-js/modules/es7.symbol.async-iterator';
import 'core-js/modules/es6.symbol';
import 'core-js/modules/es6.regexp.to-string';
import 'core-js/modules/es6.reflect.construct';
import 'core-js/modules/web.dom.iterable';
import _toConsumableArray from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray';
import 'core-js/modules/es6.function.name';
import 'core-js/modules/es6.string.iterator';
import 'core-js/modules/es6.array.from';
import _classCallCheck from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck';
import _createClass from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass';
import _get from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/get';
import _inherits from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/inherits';
import _possibleConstructorReturn from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf';
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === 'undefined' || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === 'number') {
            if (it)
                o = it;
            var i = 0;
            var F = function F() {
            };
            return {
                s: F,
                n: function n() {
                    if (i >= o.length)
                        return { done: true };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null)
                    it.return();
            } finally {
                if (didErr)
                    throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
    }
    return arr2;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module link/ui/linkformview
 */
import View from '@ckeditor/ckeditor5-ui/src/view';
import ViewCollection from '@ckeditor/ckeditor5-ui/src/viewcollection';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import SwitchButtonView from '@ckeditor/ckeditor5-ui/src/button/switchbuttonview';
import LabeledInputView from '@ckeditor/ckeditor5-ui/src/labeledinput/labeledinputview';
import InputTextView from '@ckeditor/ckeditor5-ui/src/inputtext/inputtextview';
import submitHandler from '@ckeditor/ckeditor5-ui/src/bindings/submithandler';
import FocusTracker from '@ckeditor/ckeditor5-utils/src/focustracker';
import FocusCycler from '@ckeditor/ckeditor5-ui/src/focuscycler';
import KeystrokeHandler from '@ckeditor/ckeditor5-utils/src/keystrokehandler';
import checkIcon from '@ckeditor/ckeditor5-core/theme/icons/check.svg';
import cancelIcon from '@ckeditor/ckeditor5-core/theme/icons/cancel.svg';
import '../../theme/linkform.css';
/**
 * The link form view controller class.
 *
 * See {@link module:link/ui/linkformview~LinkFormView}.
 *
 * @extends module:ui/view~View
 */
var LinkFormView = /*#__PURE__*/
function (_View) {
    _inherits(LinkFormView, _View);
    var _super = _createSuper(LinkFormView);
    /**
   * Creates an instance of the {@link module:link/ui/linkformview~LinkFormView} class.
   *
   * Also see {@link #render}.
   *
   * @param {module:utils/locale~Locale} [locale] The localization services instance.
   * @param {module:utils/collection~Collection} [manualDecorators] Reference to manual decorators in
   * {@link module:link/linkcommand~LinkCommand#manualDecorators}.
   */
    function LinkFormView(locale) {
        var _this;
        var manualDecorators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        _classCallCheck(this, LinkFormView);
        _this = _super.call(this, locale);
        var t = locale.t;
        /**
     * Tracks information about DOM focus in the form.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker}
     */
        _this.focusTracker = new FocusTracker();
        /**
     * An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
     *
     * @readonly
     * @member {module:utils/keystrokehandler~KeystrokeHandler}
     */
        _this.keystrokes = new KeystrokeHandler();
        /**
     * The URL input view.
     *
     * @member {module:ui/labeledinput/labeledinputview~LabeledInputView}
     */
        _this.urlInputView = _this._createUrlInput();
        /**
     * The Save button view.
     *
     * @member {module:ui/button/buttonview~ButtonView}
     */
        _this.saveButtonView = _this._createButton(t('Save'), checkIcon, 'ck-button-save');
        _this.saveButtonView.type = 'submit';
        /**
     * The Cancel button view.
     *
     * @member {module:ui/button/buttonview~ButtonView}
     */
        _this.cancelButtonView = _this._createButton(t('Cancel'), cancelIcon, 'ck-button-cancel', 'cancel');
        /**
     * A collection of {@link module:ui/button/switchbuttonview~SwitchButtonView},
     * which corresponds to {@link module:link/linkcommand~LinkCommand#manualDecorators manual decorators}
     * configured in the editor.
     *
     * @private
     * @readonly
     * @type {module:ui/viewcollection~ViewCollection}
     */
        _this._manualDecoratorSwitches = _this._createManualDecoratorSwitches(manualDecorators);
        /**
     * A collection of child views in the form.
     *
     * @readonly
     * @type {module:ui/viewcollection~ViewCollection}
     */
        _this.children = _this._createFormChildren(manualDecorators);
        /**
     * A collection of views that can be focused in the form.
     *
     * @readonly
     * @protected
     * @member {module:ui/viewcollection~ViewCollection}
     */
        _this._focusables = new ViewCollection();
        /**
     * Helps cycling over {@link #_focusables} in the form.
     *
     * @readonly
     * @protected
     * @member {module:ui/focuscycler~FocusCycler}
     */
        _this._focusCycler = new FocusCycler({
            focusables: _this._focusables,
            focusTracker: _this.focusTracker,
            keystrokeHandler: _this.keystrokes,
            actions: {
                // Navigate form fields backwards using the Shift + Tab keystroke.
                focusPrevious: 'shift + tab',
                // Navigate form fields forwards using the Tab key.
                focusNext: 'tab'
            }
        });
        var classList = [
            'ck',
            'ck-link-form'
        ];
        if (manualDecorators.length) {
            classList.push('ck-link-form_layout-vertical');
        }
        _this.setTemplate({
            tag: 'form',
            attributes: {
                class: classList,
                // https://github.com/ckeditor/ckeditor5-link/issues/90
                tabindex: '-1'
            },
            children: _this.children
        });
        return _this;
    }
    /**
   * Obtains the state of the {@link module:ui/button/switchbuttonview~SwitchButtonView switch buttons} representing
   * {@link module:link/linkcommand~LinkCommand#manualDecorators manual link decorators}
   * in the {@link module:link/ui/linkformview~LinkFormView}.
   *
   * @returns {Object.<String,Boolean>} Key-value pairs, where the key is the name of the decorator and the value is
   * its state.
   */
    _createClass(LinkFormView, [
        {
            key: 'getDecoratorSwitchesState',
            value: function getDecoratorSwitchesState() {
                return Array.from(this._manualDecoratorSwitches).reduce(function (accumulator, switchButton) {
                    accumulator[switchButton.name] = switchButton.isOn;
                    return accumulator;
                }, {});
            }    /**
     * @inheritDoc
     */
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                _get(_getPrototypeOf(LinkFormView.prototype), 'render', this).call(this);
                submitHandler({ view: this });
                var childViews = [this.urlInputView].concat(_toConsumableArray(this._manualDecoratorSwitches), [
                    this.saveButtonView,
                    this.cancelButtonView
                ]);
                childViews.forEach(function (v) {
                    // Register the view as focusable.
                    _this2._focusables.add(v);
                    // Register the view in the focus tracker.
                    _this2.focusTracker.add(v.element);
                });
                // Start listening for the keystrokes coming from #element.
                this.keystrokes.listenTo(this.element);
            }    /**
     * Focuses the fist {@link #_focusables} in the form.
     */
        },
        {
            key: 'focus',
            value: function focus() {
                this._focusCycler.focusFirst();
            }    /**
     * Creates a labeled input view.
     *
     * @private
     * @returns {module:ui/labeledinput/labeledinputview~LabeledInputView} Labeled input view instance.
     */
        },
        {
            key: '_createUrlInput',
            value: function _createUrlInput() {
                var t = this.locale.t;
                var labeledInput = new LabeledInputView(this.locale, InputTextView);
                labeledInput.label = t('Link URL');
                labeledInput.inputView.placeholder = 'https://example.com';
                return labeledInput;
            }    /**
     * Creates a button view.
     *
     * @private
     * @param {String} label The button label.
     * @param {String} icon The button icon.
     * @param {String} className The additional button CSS class name.
     * @param {String} [eventName] An event name that the `ButtonView#execute` event will be delegated to.
     * @returns {module:ui/button/buttonview~ButtonView} The button view instance.
     */
        },
        {
            key: '_createButton',
            value: function _createButton(label, icon, className, eventName) {
                var button = new ButtonView(this.locale);
                button.set({
                    label: label,
                    icon: icon,
                    tooltip: true
                });
                button.extendTemplate({ attributes: { class: className } });
                if (eventName) {
                    button.delegate('execute').to(this, eventName);
                }
                return button;
            }    /**
     * Populates {@link module:ui/viewcollection~ViewCollection} of {@link module:ui/button/switchbuttonview~SwitchButtonView}
     * made based on {@link module:link/linkcommand~LinkCommand#manualDecorators}.
     *
     * @private
     * @param {module:utils/collection~Collection} manualDecorators A reference to the
     * collection of manual decorators stored in the link command.
     * @returns {module:ui/viewcollection~ViewCollection} of switch buttons.
     */
        },
        {
            key: '_createManualDecoratorSwitches',
            value: function _createManualDecoratorSwitches(manualDecorators) {
                var _this3 = this;
                var switches = this.createCollection();
                var _iterator = _createForOfIteratorHelper(manualDecorators), _step;
                try {
                    var _loop = function _loop() {
                        var manualDecorator = _step.value;
                        var switchButton = new SwitchButtonView(_this3.locale);
                        switchButton.set({
                            name: manualDecorator.id,
                            label: manualDecorator.label,
                            withText: true
                        });
                        switchButton.bind('isOn').to(manualDecorator, 'value');
                        switchButton.on('execute', function () {
                            manualDecorator.set('value', !switchButton.isOn);
                        });
                        switches.add(switchButton);
                    };
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        _loop();
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally {
                    _iterator.f();
                }
                return switches;
            }    /**
     * Populates the {@link #children} collection of the form.
     *
     * If {@link module:link/linkcommand~LinkCommand#manualDecorators manual decorators} are configured in the editor, it creates an
     * additional `View` wrapping all {@link #_manualDecoratorSwitches} switch buttons corresponding
     * to these decorators.
     *
     * @private
     * @param {module:utils/collection~Collection} manualDecorators A reference to
     * the collection of manual decorators stored in the link command.
     * @returns {module:ui/viewcollection~ViewCollection} The children of link form view.
     */
        },
        {
            key: '_createFormChildren',
            value: function _createFormChildren(manualDecorators) {
                var children = this.createCollection();
                children.add(this.urlInputView);
                if (manualDecorators.length) {
                    var additionalButtonsView = new View();
                    additionalButtonsView.setTemplate({
                        tag: 'ul',
                        children: this._manualDecoratorSwitches.map(function (switchButton) {
                            return {
                                tag: 'li',
                                children: [switchButton],
                                attributes: {
                                    class: [
                                        'ck',
                                        'ck-list__item'
                                    ]
                                }
                            };
                        }),
                        attributes: {
                            class: [
                                'ck',
                                'ck-reset',
                                'ck-list'
                            ]
                        }
                    });
                    children.add(additionalButtonsView);
                }
                children.add(this.saveButtonView);
                children.add(this.cancelButtonView);
                return children;
            }
        }
    ]);
    return LinkFormView;
}(View);
/**
 * Fired when the form view is submitted (when one of the children triggered the submit event),
 * for example with a click on {@link #saveButtonView}.
 *
 * @event submit
 */
/**
 * Fired when the form view is canceled, for example with a click on {@link #cancelButtonView}.
 *
 * @event cancel
 */
export {
    LinkFormView as default
};